import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <div>
        <div>
            <div className="copyright">
            <p>© 2025 Luminara. All rights reserved.</p>
          </div>
        </div>
    </div>
  )
}

export default Footer